import React from 'react';

const ReleaseNotes = () => {
    return (
        <main className="">
            <h2 className="mt-5  font-bold  text-xl">Other News</h2>
            <div className="space-y-4  mt-2  p-5  rounded  bg-slate-100">
                The website is currently undergoing an overhaul in the background. Everything is now up to date and all data is now sourced from Wahapedia<br/>
                Once this is done then I can finish the list building feature and start adding more features such as exporting, saving, and list viewing.<br/>
            </div>

            <h2 className="font-bold  text-xl">Recently Added/Fixed</h2>

            <div className="space-y-4  mt-2  p-5  rounded  bg-slate-100">
                <div>
                    <strong>05/03/2025</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>Updated with new Eldar Codex</li>
                    </ul>
                </div>
                <div>
                    <strong>01/02/2025</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>Added all stratagems that are fully searchable</li>
                        <li>Added stratagems to every linked unit that are clickable directly</li>
                    </ul>
                </div>
                <div>
                    <strong>31/01/2025</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>Updated all units to the latest ones</li>
                        <li>Added a url system so now you can easier share units with others as well as not needing to nagivate back after refresh (lists still do not save though)</li>
                    </ul>
                </div>
                <div>
                    <strong>11/07/2023</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>Updated all points</li>
                    </ul>
                </div>
                <div>
                    <strong>23/06/2023</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>Added all forgeworld models with points</li>
                    </ul>
                </div>
                <div>
                    <strong>22/06/2023</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>Added: Stormwolf gunship</li>
                        <li>Fixed character linking for possessed, cultist mob, and legionaries</li>
                    </ul>
                </div>

                <div>
                    <strong>20/06/2023</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>Added: Razorwing jetfighter</li>
                        <li>Fixed some CP costs</li>
                        <li>Added points for primaris sword bretheren</li>
                        <li>Added Belakors abilities</li>
                    </ul>
                </div>

                <div>
                    <strong>19/06/2023</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>Set up a very basic discord <a className="underline" href="https://discord.gg/SVjUb93FqB">Discord Link</a></li>
                        <li>Added: Helverins, Executioners, Lord Solar Leontus, Voidsmen-at-Arms, Asurmen, Eightbound, all the space marine chapter specific characters</li>
                        <li>Fixed Points: Lootas, burners, Primaris Crusader Squad, Crusader Squad</li>
                        <li>Fixed crashes for: Tsons sorcerer in terminator armor</li>
                        <li>Removed M T SV W LD OC from tyranids for being too OP</li>
                    </ul>
                </div>

                <div>
                    <strong>18/06/2023</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>Added a tiny patreon button on the menu</li>
                        <li>Hopefully fixed all missing and broken units (apart from space marines chapters like ultramarines, whitescars etc)</li>
                        <li>Added Stratagems</li>
                        <li>Added a home button</li>
                        <li>Changed dedicated transports to be correctly maximum of 6 now</li>
                        <li>Fixed styling throughout the app</li>
                    </ul>
                </div>

                <div>
                    <strong>16/06/2023</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>You can now save units by clicking the plus and minus button and it will show the total points. This is limited by: epic hero (1), battleline (6), everything else (3)</li>
                        (This is a bit funky right now until I fix it properly. Rather than being able to choose minimum size units it will make the next size up if possible, then create a new one. It shows the current count of models)
                        <li>Added a clear all data button </li>
                        <li>Started adding more keywords (Sisters is done - more to come soon)</li>
                    </ul>
                </div>

                <div>
                    <strong>15/06/2023</strong>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li>All Xenos Indexes have been added</li>
                        <li>The hamburger menu should now remember its state</li>
                        <li>All models that can lead units and all units that can be lead now have clickable keywords to go to that unit directly</li>
                        <li>Fixed displaying of invulnerable saves</li>
                        <li>Datasheets now show alphabetically</li>
                    </ul>
                </div>
            </div>

            <h2 className="mt-5  font-bold  text-xl">Known Issues</h2>
            <div className="space-y-4  mt-2  p-5  rounded  bg-slate-100">
                <div>
                    <ul className="space-y-1  mt-1  pl-4  list-[square]">
                        <li><s>Leader keywords can be missing from forgeworld models</s></li>
                        <li><s>Abilities text can be missing from forgeworld models also</s></li>
                        <li><s>Some units have a '■' in them, causing the link to not work properly from the leader page</s></li>
                        <li><s>Leader section can have extra data in it</s></li>
                        <li>There is an issue with state handling, so if you refresh the page you will loose all work done</li>
                        <li><s>Some stratagems have the wrong cost</s></li>
                        <li><s>Some stratagem pages have a ghost stratagem named after the detachment</s></li>
                        <li>Codex compliant chapter units are missing</li>
                        <li><s>Some stratagems aren't correct</s></li>
                        <li><s>There are some erroneous entries, like "armoury"</s></li>
                        <li><s>Some units are missing (list to be generated)</s></li>
                        <li>Missing a main menu, this will be rebuilt once more features are added</li>
                        <li><s>Keywords are missing on some units</s></li>
                        <li><s>Some weapons have erroneous entries</s></li>
                        <li><s>Abilities is still a mess and not easy to read</s></li>
                        <li><s>Angron stole Kharns pistol</s></li>
                        <li><s>Some keywords have borrowed the first number from ranged weapons</s></li>
                        <li><s>One-shot keyword is missing</s></li>
                        <li><s>Fortifications don't display correctly</s></li>
                        <li>Burger menu subitems can't be closed once opened</li>
                    </ul>
                </div>
            </div>

            <h2 className="mt-5  font-bold  text-xl">Requested / Future Features</h2>
            <div className="space-y-4  mt-2  p-5  rounded  bg-slate-100">
                <ul className="space-y-1  pl-4  list-[square]">
                    <li>More robust list building</li>
                    <li>List Exporting and printing</li>
                    <li>Army rules</li>
                </ul>
            </div>
        </main>
    );
};

export default ReleaseNotes;